<template>
  <div>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="row">
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Zone:</label>
              <v-select
                class="custom-select-height"
                label="name"
                :options="ZonesList"
                v-model="zone_filter"
              />
            </div>
          </div>
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Livreur :</label>
              <v-select
                class="custom-select-height"
                label="name"
                :options="LivreursList"
                v-model="liv_filter"
              >
              </v-select>
            </div>
          </div>
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Statut:</label>
              <select
                class="custom-select-height form-control"
                v-model="status_filter"
              >
                <option value="" selected>Status (Tous)</option>
                <option :value="0" selected>Nouveau</option>
                <option :value="1" selected>Enregistré</option>
                <option :value="2">Payé</option>
              </select>
            </div>
          </div>

          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Par Date :</label>
              <div class="border p-2 cursor-pointer" @click="showCalendar()">
                {{ selectedDate?.[0]?.format("DD MMM YYYY") || "—" }}
                -
                {{ selectedDate?.[1]?.format("DD MMM YYYY") || "—" }}
                <i class="flaticon-calendar float-end"></i>
              </div>

              <div
                v-show="showCalendarBox"
                class="position-relative mt-2 p-2 bg-white shadow rounded"
                style="z-index: 999"
              >
                <MyDateRangePicker
                  v-model="selectedDate"
                  @onSelect="showCalendar"
                  :enableSecondCalendar="true"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Créer par:</label>
              <v-select
                class="custom-select-height"
                v-model="created_filter"
                label="name"
                :options="CuserList"
                @search="onSearchUsers"
              >
              </v-select>
            </div>
          </div>
          <!-- <div class="col-md-4">
              <div class="form-group">
                <label>Chercher :</label>
                <input 
                  v-model="searchTerm"
                  class="form-control"
                  placeholder="Chercher">
                </input>
              </div>
            </div> -->
          <div class="col-md-4 mb-20">
            <button
              style="margin-top: 22px"
              class="btn btn-primary"
              @click="applyFilters()"
            >
              <i class="flaticon-search" style="margin-right: 5px"></i>
              Filtrer
            </button>
            <button
              style="margin-top: 22px"
              class="btn btn-danger"
              @click="resetFilters()"
            >
              <i class="flaticon-close" style="margin-right: 5px"></i>
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <!-- Header bar -->
      <div class="p-15 p-md-20 border-bottom d-flex flex-wrap align-items-center justify-content-between gap-2">
        <!-- Left: per-page + actions -->
        <div class="d-flex align-items-center flex-wrap gap-2">
          <div class="d-flex align-items-center gap-1">
            <label class="mb-0 text-nowrap">Voir</label>
            <v-select
              v-model="users.per_page"
              :options="[10, 25, 50]"
              :clearable="false"
              class="per-page-selector d-inline-block"
              style="min-width: 75px"
              @input="getRecords()"
            />
            <label class="mb-0 text-nowrap">sur {{ users.total }} entités</label>
          </div>

          <button
            :disabled="load"
            class="btn btn-sm btn-outline-secondary"
            @click="handelTotal(0)"
          >
            <span class="spinner-border spinner-border-sm me-1" v-if="load"></span>
            <i class="flaticon-calculator me-1" v-else></i>
            Total sélection
          </button>

          <button
            :disabled="load"
            class="btn btn-sm btn-outline-info"
            @click="handelTotal(1)"
          >
            <span class="spinner-border spinner-border-sm me-1" v-if="load"></span>
            <i class="flaticon-calculator me-1" v-else></i>
            Total (Tous)
          </button>

          <span v-if="showTotal && total" class="fw-semibold text-dark">
            Total : <b class="text-success">{{ total }} DH</b>
          </span>

          <button
            class="btn btn-sm btn-outline-success"
            :disabled="selectedPays.length === 0"
            @click="exportSelected"
          >
            <i class="flaticon-download me-1"></i>
            Exporter sélection
          </button>

          <router-link
            v-if="auth.can('ADD_BP_L')"
            class="btn btn-sm btn-primary"
            :to="{ name: 'NewPaymentPage' }"
          >
            <i class="flaticon-plus me-1"></i>
            Ajouter Bon
          </router-link>

          <button
            v-if="auth.can('ADD_BP_L')"
            class="btn btn-sm btn-info"
            @click="autoAddedNotes()"
          >
            <i class="flaticon-refresh me-1"></i>
            Auto-ajouter
          </button>
        </div>

        <!-- Right: Search -->
        <div class="position-relative">
          <input
            v-model="users.searchTerm"
            type="text"
            class="form-control form-control-sm rounded-1 ps-4"
            style="min-width: 260px"
            placeholder="Rechercher..."
            @input="handleInput"
          />
          <i
            class="flaticon-search position-absolute top-50 translate-middle-y ms-2"
            style="left: 0; opacity: 0.4; pointer-events: none"
          ></i>
        </div>
      </div>

      <div class="p-15 p-md-20">

      <vue-good-table
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        }"
        @selected-rows-change="selectPays"
        @select-all="onSelectAllPays"
        :columns="columns"
        :rows="rows"
        responsive
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <span v-if="props.column.field === 'note_ref'" class="text-nowrap">
            <b>{{ props.row.note_ref }}</b>
          </span>

          <span
            v-else-if="props.column.field === 'zone_name'"
            class="text-nowrap"
          >
            {{ props.row.zone_name }}<br />
            {{ props.row.agency_name }}
          </span>

          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            <template v-if="props.row.created_at != null">
              {{ getDate(props.row.created_at) }}<br />
            </template>
            {{ props.row.by_name }}
          </span>
          <span v-else-if="props.column.field === 'total'" class="text-nowrap">
            {{ props.row.total }}
            DH
          </span>
          <!-- <span
            v-else-if="props.column.field === 'note_saved_time'"
            class="text-nowrap"
          >
            <h5 v-if="props.row.note_saved_time!=null">{{ getDate(props.row.note_saved_time) }}</h5>
            <center><span>{{props.row.note_saved_by_name}}</span></center>
          </span> -->

          <template v-else-if="props.column.field === 'statut'">
            <span
              v-if="props.row.statut == 0"
              class="badge rounded-pill fs-13 text-bg-danger"
            >
              Nouveau
            </span>
            <span
              v-else-if="props.row.statut == 1"
              class="badge rounded-pill fs-13 text-bg-info"
            >
              Enregistré
            </span>
            <span
              v-else-if="props.row.statut == 2"
              class="badge rounded-pill fs-13 text-bg-success"
            >
              Payé
            </span>
          </template>
          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-if="auth.can('BP_L')">
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="
                      openNewWindow(
                        `/edit-payment-note/${props.row.id}/${props.row.note_ref}`
                      )
                    "
                  >
                    <i class="flaticon-eye me-2"></i>
                    Détails du Bon
                  </a>
                </li>
                <li
                  v-if="
                    props.row.statut == 0 &&
                    props.row.total_parcel == 0 &&
                    auth.can('BP_L')
                  "
                >
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="RemoveNote(props.row)"
                  >
                    <i class="flaticon-delete me-2"></i>
                    Supprimer le Bon
                  </a>
                </li>
                <li
                  v-if="
                    props.row.statut == 0 &&
                    props.row.total_parcel != 0 &&
                    auth.can('BP_L')
                  "
                >
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="SaveBon(props.row)"
                  >
                    <i class="flaticon-diskette me-2"></i>
                    Enregistrer le bon
                  </a>
                </li>
                <li
                  v-if="
                    props.row.statut == 1 &&
                    props.row.total_parcel != 0 &&
                    auth.can('BP_L')
                  "
                >
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="OpenBon(props.row)"
                  >
                    <i class="flaticon-unlock me-2"></i>
                    Ouvrir le bon
                  </a>
                </li>
                <li
                  v-if="
                    props.row.statut == 1 &&
                    props.row.total_parcel != 0 &&
                    props.row.total > 0 &&
                    auth.can('BP_L') &&
                    auth.can('PAID_BP_L')
                  "
                >
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="showModalPaid(props.row)"
                  >
                    <i class="flaticon-money me-2"></i>
                    Changer En Payé
                  </a>
                </li>
                <li v-if="props.row.total_parcel != 0">
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="GetPDF(props.row)"
                  >
                    <i class="flaticon-download me-2"></i>
                    Télécharger le bon
                  </a>
                </li>
                <li v-if="props.row.total_parcel != 0">
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="exportPayNote(props.row)"
                  >
                    <i class="flaticon-file me-2"></i>
                    Exporter Excel
                  </a>
                </li>
                <!-- <li>
                  <a
                    class="dropdown-item"
                    href="#"
                    target="_blank"
                    title="Groupe Whatsapp"
                  >
                    <i class="flaticon-message me-2"></i>
                    Groupe Whatsapp
                  </a>
                </li> -->
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="getRecords"
      />
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modal_PaidBox"
    tabindex="-1"
    aria-labelledby="modalPaidBoxLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalPaidBoxLabel">
            Paiment Bon {{ form.note_ref }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-12">
              <span
                >Montant à payé: <b>{{ form.total }}</b></span
              >
            </div>
          </div>
          <hr />
          <div class="row mb-3">
            <div class="col-12">
              <label for="price" class="form-label">Montant payé</label>
              <input
                type="number"
                min="0"
                id="price"
                v-model="pricePaid"
                class="form-control"
                placeholder="Montant Payé"
              />
            </div>
          </div>
          <!-- <div class="row mb-3">
          <div class="col-12">
          <label for="caisse" class="form-label">Choisir la caisse :</label>
          <v-select :options="Caisses" v-model="caisse" label="name" class="custom-select-height" />
          </div>
        </div> -->
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Annuler
          </button>
          <button type="button" class="btn btn-primary" @click="BonPaid(form)">
            Payé
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ref, reactive } from "vue";
import { useAuthStore } from "@/stores/auth";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { onMounted } from "vue";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import MyDateRangePicker from "@/components/MyDateRangePicker.vue";
import { watch } from "vue";

export default defineComponent({
  components: {
    MyDateRangePicker,
  },
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const isLoader = ref(false);
    const load = ref(false);
    const pageLength = ref(10);
    const loading = ref(false);
    const columns = [
      { label: "Référence", field: "note_ref" },
      { label: "Date de création", field: "created_at" },
      { label: "Zone", field: "zone_name" },
      { label: "Livreur", field: "for_name" },
      { label: "Statut", field: "statut" },
      { label: "Colis", field: "total_parcel" },
      { label: "Total", field: "total" },
      { label: "Actions", field: "action", width: "180px" },
    ];
    const rows = ref([]);
    const LivreursList = ref([]);
    const ZonesList = ref([]);
    const CuserList = ref([]);
    const zone_filter = ref({ id: "", name: "" });
    const liv_filter = ref({ id: "", name: "" });
    const created_filter = ref({ id: "", name: "" });
    const status_filter = ref("");
    const date_filter = ref("");
    const users = reactive({
      searchTerm: "",
      searchZone: "",
      searchLiv: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      searchUser: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const offset = ref(9);
    const row_ref = ref({});
    const pricePaid = ref("");
    const form = reactive({
      id: 0,
      note_ref: "",
      total: "",
    });
    const Caisses = ref([]);
    const caisse = ref<{ id?: string | number; name?: string }>({});
    const selectedPays = ref([]);
    const showTotal = ref(false);
    const total = ref("");

    onMounted(async () => {
      getRecords();
      try {
        const response = await api.get(`/api/auth/ListZone`);
        ZonesList.value = response.data;
        ZonesList.value.unshift({ id: "", name: "Tous" });
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      }
    });

    const debounceTimer = ref(null);

    function onSearchZones(search, loading) {
      if (search.length && ZonesList.value.length === 0) {
        loading(true);
        api.get(`/api/auth/ListZone`).then((response) => {
          ZonesList.value = response.data;
          ZonesList.value.unshift({ id: "", name: "Tous" });
          loading(false);
        });
      }
    }

    function onSearchCaisses(search, loading) {
      if (search.length && Caisses.value.length === 0) {
        loading(true);
        api.get(`/api/auth/ListCaisse`).then((response) => {
          Caisses.value = response.data;
          loading(false);
        });
      }
    }

    function getDate(value) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function resolveUserStatusVariant(status) {
      if (status === 0) return "danger";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "warning";
    }

    function showModalPaid(row) {
      form.id = 0;
      form.note_ref = "";
      form.total = "";
      caisse.value = {};
      pricePaid.value = "";
      form.id = row.id;
      form.note_ref = row.note_ref;
      form.total = row.total;
      const modalEl = document.getElementById("modal_PaidBox");
      const modal = new Modal(modalEl);
      modal.show();
    }

    function convert(str) {
      const date = new Date(str);
      const mnth = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    function applyFilters() {
      users.searchZone = zone_filter.value.id;
      users.searchLiv = liv_filter.value.id;
      users.searchStatut = status_filter.value;
      users.searchUser = created_filter.value.id;
      // Date range
      users.searchSDate = selectedDate.value?.[0]
        ? selectedDate.value[0].format("YYYY-MM-DD")
        : "";

      users.searchEDate = selectedDate.value?.[1]
        ? selectedDate.value[1].format("YYYY-MM-DD")
        : "";
      users.searchTerm =
        users.searchTerm !== "undefined" ? users.searchTerm : "";
      users.current_page = 1;
      getRecords();
    }

    function resetFilters() {
      users.searchZone = "";
      users.searchUser = "";
      users.searchLiv = "";
      users.searchStatut = "";
      users.searchTerm = "";
      status_filter.value = "";
      users.searchSDate = "";
      users.searchEDate = "";
      date_filter.value = "";
      zone_filter.value = { id: "", name: "" };
      liv_filter.value = { id: "", name: "" };
      created_filter.value = { id: "", name: "" };
      users.current_page = 1;
      selectedDate.value = null;
      // if (this.$refs?.myInput) this.$refs.myInput.dateRange = {};
      getRecords();
    }

    function handleInput() {
      if (debounceTimer.value) clearTimeout(debounceTimer.value);
      debounceTimer.value = setTimeout(() => {
        applyFilters();
      }, 400);
    }

    function getRecords(page = 1) {
      isLoader.value = true;
      users.current_page = page;
      api
        .get(
          `/api/auth/payment_liv_list?searchTerm=${users.searchTerm}&searchZone=${users.searchZone}&searchUser=${users.searchUser}&searchLiv=${users.searchLiv}&searchStatut=${users.searchStatut}&searchSDate=${users.searchSDate}&searchEDate=${users.searchEDate}&page=${users.current_page}&per_page=${users.per_page}`
        )
        .then((response) => {
          rows.value = response.data.users.data;
          Object.assign(users, response.data.users);
          isLoader.value = false;
        });
    }

    function DestroyBrc(brc) {
      const data = new FormData();
      data.append("reception_note_id", brc.id);
      data.append("cstmr_id", brc.note_customer);
      // api.post(`/api/auth/DestroyBrc`, data)
    }

    function showModal(row) {
      row_ref.value = row.note_ref;
    }

    function SaveBon(row) {
      Swal.fire({
        text: "Vous voulez enregistrer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, enregistrer!",
      }).then((result) => {
        if (result.value) {
          api
            .post(`/api/auth/save_bp/${row.id}`)
            .then((res) => {
              if (res.data.message === "success") {
                showToast("Bon est bien enregistré", "success");
                applyFilters();
              } else if (
                res.data.message === "not exist" ||
                res.data.message === "no parcel"
              ) {
                showToast("Vous pouvez pas enregistrer ce bon", "error");
              } else {
                showToast("Un erreur ! ", "error");
              }
            })
            .catch(() => {
              showToast("Something went wrong! Pleaz try again", "error");
            });
        }
      });
    }

    function OpenBon(row) {
      api
        .post(`/api/auth/unsave_bp/${row.id}`)
        .then((res) => {
          if (res.data.message === "success") {
            applyFilters();
            showToast("Bon est bien ouvert", "success");
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no parcel"
          ) {
            showToast("Vous pouvez pas ouvrir ce bon", "error");
          } else {
            showToast("Un erreur ! ", "error");
          }
        })
        .catch(() => {
          showToast("Something went wrong! Pleaz try again", "error");
        });
    }

    function BonPaid(row) {
      if (
        !pricePaid.value ||
        pricePaid.value == null ||
        pricePaid.value === "" ||
        Number(form.total) < Number(pricePaid.value)
        // || Object.keys(caisse.value).length === 0
      ) {
        showToast(
          "Champs obligatoire, Merci de remplir tous les champs",
          "error"
        );
      } else {
        const data = new FormData();
        data.append("note_ref", form.note_ref);
        data.append("note_id", form.id.toString());
        data.append("amount", pricePaid.value);
        // data.append("caisse_id", String(caisse.value.id));
        // data.append("caisse_name", caisse.value.name);
        api
          .post(`/api/auth/Paid_bp`, data)
          .then((res) => {
            if (res.data.message === "success") {
              const modalEl = document.getElementById("modal_PaidBox");
              if (modalEl) {
                const modalInstance =
                  Modal.getInstance(modalEl) || new Modal(modalEl);
                modalInstance.hide();
              }
              showToast("Bon est bien payé", "success");
              applyFilters();
            } else if (
              res.data.message === "not exist" ||
              res.data.message === "no parcel"
            ) {
              showToast("Vous pouvez pas payé ce bon", "error");
            } else {
              showToast("Un erreur ! ", "error");
            }
          })
          .catch(() => {
            showToast("Something went wrong! Pleaz try again", "error");
          });
      }
    }

    function GetPDF(row) {
      api
        .get(`/api/auth/PAYMPDF/${row.id}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

    function RemoveNote(row) {
      Swal.fire({
        text: "Vous voulez supprimer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then((result) => {
        if (result) {
          api.post(`/api/auth/remove_pay_note/${row.id}`).then((res) => {
            if (res.data.message === "success") {
              applyFilters();
              showToast("Bon est bien supprimé", "success");
            } else if (
              res.data.message === "error note" ||
              res.data.message === "no data"
            ) {
              showToast("Vous pouvez pas supprimer ce bon", "error");
            }
          });
        }
      });
    }

    async function fetchLivs(zone) {
      console.log("Selected zone:", zone);
      LivreursList.value = [];

      if (!zone || !zone.id) return;

      try {
        const res = await api.get(`/api/auth/LivsZone/${zone.id}`);
        LivreursList.value = res.data;
        LivreursList.value.unshift({ id: "", name: "Tous" });
      } catch (e) {
        console.error("Error fetching livreurs", e);
      }
    }

    function onSearchUsers(search, loading) {
      if (search.length && CuserList.value.length === 0) {
        loading(true);
        api.get(`/api/auth/SelectList`).then((response) => {
          CuserList.value = response.data;
          CuserList.value.unshift({ id: "", name: "Tous" });
          loading(false);
        });
      }
    }

    function openNewWindow(url) {
      window.open(url, "_blank");
    }

    function selectPays(params) {
      selectedPays.value = params.selectedRows;
    }

    function onSelectAllPays(params) {
      selectedPays.value = params.selectedRows;
    }

    function handelTotal(x) {
      showTotal.value = false;
      if (x === 0) {
        if (!selectedPays.value || selectedPays.value.length === 0) {
          showToast(
            "Vous devez sélectionner au moins un bon pour calculer le total",
            "error"
          );
        } else {
          const data = new FormData();
          const payIds = [];
          for (let j = 0; j < selectedPays.value.length; ++j) {
            payIds.push(selectedPays.value[j].id);
          }
          data.append("payIds", JSON.stringify(payIds));
          data.append("type", "list");
          load.value = true;
          api
            .post(`/api/auth/handelTotal`, data)
            .then((res) => {
              load.value = false;
              if (res.data.success) {
                total.value = res.data.total;
                showTotal.value = true;
                showToast("Total est bien calculé", "success");
              } else {
                showToast(res.data.message, "error");
              }
            })
            .catch(() => {
              showToast("Something went wrong! Pleaz try again", "error");
            });
        }
      } else if (x === 1) {
        const data = new FormData();
        data.append("type", "all");
        load.value = true;
        api
          .post(`/api/auth/handelTotal`, data)
          .then((res) => {
            load.value = false;
            if (res.data.success) {
              total.value = res.data.total;
              showTotal.value = true;
              showToast("Total est bien calculé", "success");
            } else {
              showToast(res.data.message, "error");
            }
          })
          .catch(() => {
            showToast("Something went wrong! Pleaz try again", "error");
          });
      }
    }

    const todayDt = moment();
    const firstDt = moment().subtract(8, "M");
    const selectedDate = ref(null);

    const showCalendarBox = ref(false);

    function showCalendar() {
      console.log(selectedDate.value);
      showCalendarBox.value = !showCalendarBox.value;
    }

    watch(zone_filter, (zone) => {
      fetchLivs(zone);
    });

    function exportSelected() {
      if (!selectedPays.value || selectedPays.value.length === 0) {
        showToast("Veuillez sélectionner au moins un bon", "error");
        return;
      }

      const ids = selectedPays.value.map((row) => row.id);

      api
        .post(
          "/api/auth/export-payment-notes",
          { ids },
          { responseType: "blob" } // IMPORTANT
        )
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "bons_livreur_selection.xlsx";
          link.click();
        })
        .catch(() => {
          showToast("Erreur lors de l’export", "error");
        });
    }
    function autoAddedNotes() {
      Swal.fire({
        title: "Confirmer l’action",
        text: "Voulez-vous générer automatiquement les bons de paiement ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#075e54",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, générer!",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (!result.isConfirmed) return;
        api
          .post("/api/auth/auto_add_pay_notes")
          .then((response) => {
            if (response.data?.success) {
              if (response.data?.created != 0) {
                showToast("Bons ajoutés avec succès", "success");
                getRecords();
              } else {
                showToast("Aucun bon de paiement créé", "warning");
                getRecords();
              }
            } else {
              showToast(response.data?.message ?? "Erreur lors de l’ajout", "error");
            }
          })
          .catch(() => {
            showToast("Erreur lors de l’ajout des bons", "error");
          });
      });
    }
    function exportPayNote(row) {
      if (!row) {
        showToast("Veuillez sélectionner un bon", "error");
        return;
      }

      api
        .post(
          "/api/auth/export-payment-notes",
          { ids: [row.id] },
          { responseType: "blob" }
        )
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "bons_livreur_" + row.id + ".xlsx";
          link.click();
        })
        .catch(() => {
          showToast("Erreur lors de l’export", "error");
        });
    }

    return {
      isLoader,
      load,
      pageLength,
      loading,
      columns,
      rows,
      LivreursList,
      ZonesList,
      CuserList,
      zone_filter,
      liv_filter,
      created_filter,
      status_filter,
      date_filter,
      users,
      offset,
      row_ref,
      pricePaid,
      form,
      Caisses,
      caisse,
      selectedPays,
      showTotal,
      total,

      onSearchZones,
      onSearchCaisses,
      getDate,
      resolveUserStatusVariant,
      showModalPaid,
      convert,
      applyFilters,
      resetFilters,
      handleInput,
      getRecords,
      DestroyBrc,
      showModal,
      SaveBon,
      OpenBon,
      BonPaid,
      GetPDF,
      RemoveNote,
      fetchLivs,
      onSearchUsers,
      openNewWindow,
      selectPays,
      onSelectAllPays,
      handelTotal,
      auth,
      user,
      todayDt,
      firstDt,
      selectedDate,
      showCalendarBox,
      showCalendar,

      exportSelected,
      exportPayNote,
      autoAddedNotes
    };
  },
});
</script>
